import { useEffect, useRef } from 'react'

/**
 * Raccourci d'ouverture d'une recherche (#109) : Ctrl/⌘ K, celle des palettes
 * de commande. Il ne s'écrit pas, il reste donc actif partout. Le comportement
 * du navigateur est empêché : Ctrl K y donne le focus à sa barre d'adresse.
 *
 * « / » a été retiré (RGAA 12.10) : un raccourci d'une seule touche, ni
 * désactivable ni modifiable, se déclenche par accident en commande vocale.
 */
export function useSearchShortcut(onTrigger: () => void): void {
  // Le dernier `onTrigger` sans réabonner l'écoute à chaque rendu.
  const latest = useRef(onTrigger)
  useEffect(() => {
    latest.current = onTrigger
  })

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      const commandK = (event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k'
      if (!commandK) return
      event.preventDefault()
      latest.current()
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [])
}
